module.exports = __webpack_public_path__ + "static/discover-logo-64ffbe7fb30ee95420ecab80f8fb7de2.png";